var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup268(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7108 0H4.91425C2.3768 0 0.3125 2.0643 0.3125 4.60175V12.3984C0.3125 14.9357 2.3768 17 4.91425 17H12.7109C15.2482 17 17.3125 14.9357 17.3125 12.3984V4.60175C17.3125 2.0643 15.2482 0 12.7108 0V0ZM8.8125 13.1483C6.24937 13.1483 4.16419 11.0631 4.16419 8.5C4.16419 5.93687 6.24937 3.85169 8.8125 3.85169C11.3756 3.85169 13.4608 5.93687 13.4608 8.5C13.4608 11.0631 11.3756 13.1483 8.8125 13.1483ZM13.572 4.94791C12.8145 4.94791 12.1984 4.33184 12.1984 3.57439C12.1984 2.81695 12.8145 2.20074 13.572 2.20074C14.3294 2.20074 14.9456 2.81695 14.9456 3.57439C14.9456 4.33184 14.3294 4.94791 13.572 4.94791Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81283 5.6665C7.25059 5.6665 5.97949 6.9375 5.97949 8.49984C5.97949 10.0621 7.25059 11.3332 8.81283 11.3332C10.3752 11.3332 11.6462 10.0621 11.6462 8.49984C11.6462 6.9375 10.3752 5.6665 8.81283 5.6665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5722 3.19775C13.3644 3.19775 13.1953 3.36688 13.1953 3.57466C13.1953 3.78244 13.3644 3.95157 13.5722 3.95157C13.7801 3.95157 13.9493 3.78257 13.9493 3.57466C13.9493 3.36675 13.7801 3.19775 13.5722 3.19775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup268);
export default __webpack_public_path__ + "static/media/Group 268.8bff78e541011dbc64627bd06b5a673d.svg";
export { ForwardRef as ReactComponent };